import { io } from 'socket.io-client';

let socket = null;

// 'connected' | 'reconnecting' | 'disconnected'
let status = 'disconnected';
const statusListeners = new Set();

function setStatus(next) {
  if (status === next) return;
  status = next;
  statusListeners.forEach(fn => { try { fn(status); } catch (_) {} });
}

// Subscribe to live-connection state (drives the navbar LiveDot).
// Calls fn immediately with the current status; returns an unsubscribe.
export function onSocketStatus(fn) {
  statusListeners.add(fn);
  fn(status);
  return () => statusListeners.delete(fn);
}

export function connectSocket() {
  // One socket per session. A disconnected-but-existing socket is still
  // auto-reconnecting — returning it here avoids stacking duplicates when
  // several mounts call connectSocket() in the same tick.
  if (socket) return socket;

  const token = localStorage.getItem('token');
  if (!token) return null;

  const url = process.env.REACT_APP_WS_URL || window.location.origin;
  socket = io(url, {
    // Callback form: re-read the token on EVERY (re)connect attempt, so a
    // token refreshed by the HTTP interceptor is picked up instead of
    // replaying the stale JWT until reconnection gives up.
    auth: (cb) => cb({ token: localStorage.getItem('token') }),
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 2000,
    reconnectionDelayMax: 30000,
  });

  socket.on('connect', () => setStatus('connected'));
  socket.on('disconnect', (reason) => {
    console.log('Socket disconnected:', reason);
    // 'io client disconnect' = we called disconnect(); anything else and
    // socket.io is retrying in the background.
    setStatus(reason === 'io client disconnect' ? 'disconnected' : 'reconnecting');
  });
  socket.on('connect_error', (err) => {
    console.error('Socket error:', err.message);
    setStatus('reconnecting');
  });

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
  setStatus('disconnected');
}

export function getSocket() {
  return socket;
}
